import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';
import { loginWithToken } from '../services/authService';

const SamlCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('access');
    const refreshToken = urlParams.get('refresh');
    const tenantId = urlParams.get('tenant_id');

    if (!accessToken || !refreshToken) {
      console.error('SamlCallback: Missing access or refresh token in query parameters.');
      navigate('/'); // Redirect to home or login page
      return;
    }

    try {
      // Decode the access token to extract tenant information
      const decodedToken = jwtDecode(accessToken);

      // Store tokens in localStorage
      loginWithToken(accessToken, refreshToken, decodedToken.tenants?.[0]?.id);

      // Extract tenant information
      console.log('SamlCallback: tenantId from URL params:', tenantId);
      const tenant = decodedToken.tenants?.find(t => t.tenant_id === tenantId) || decodedToken.tenants?.[0];
    //   const tenant = decodedToken.tenants?.[0]; // Assuming the first tenant is the default
      if (tenant && tenant.subdomain_prefix) {
        navigate(`/app/${tenant.subdomain_prefix}/dashboard`); // Redirect to tenant's dashboard
      } else {
        console.error('SamlCallback: No tenant information found in token.');
        navigate('/'); // Redirect to home or login page
      }
    } catch (error) {
      console.error('SamlCallback: Error decoding token.', error);
      navigate('/'); // Redirect to home or login page
    }
  }, [navigate]);

  return <div>Processing SAML callback...</div>;
};

export default SamlCallback;
